// Angular
import { Injectable } from '@angular/core';
// Intent
import { SacAipIntent } from '../../sac-aip.intent';

@Injectable()
export class TokenService {
  token: string = null;
  refreshToken: boolean;
  foundExpiredAccessToken: boolean;

  constructor(private intent: SacAipIntent) {}

  public getToken(): any {
    if (this.token === undefined || this.token === null || this.foundExpiredAccessToken) {
      // this will fetch a new token if the previous one was expired
      // this.token = this.intent.getFreshToken();
    }
    return this.token;
  }

  public getTokenCallBackAsync(objCallBack?: any): void {
    if (this.token === undefined || this.token === null || this.foundExpiredAccessToken) {
      // this will fetch a new token if the previous one was expired
      // this.token = this.intent.getFreshToken(objCallBack);
    } else if (objCallBack) {
      objCallBack.getTokenCallBack(this.token);
    }
  }
}
